// extracted by mini-css-extract-plugin
module.exports = {"hidden":"paccResult_hidden__Rwtrb","textEmphasis":"paccResult_textEmphasis__2TAD_","resultArea":"paccResult_resultArea__TB0uz"};